<template>
  <div id="register_box">
    <div class="rg_form_box"
    v-loading="loginLoading"
    element-loading-text="注册成功,正在登录中..."
    element-loading-spinner="el-icon-loading"
    >
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>加入绿盟</span>
          <el-divider></el-divider>
        </p>
      </div>
      <div class="rg_form_box_title">
        <p class="rg_title active">会员注册</p>
      </div>
      <el-form class="rg_form_box_form" method="POST" :model="user" :rules="rules" ref="registerForm" @submit.prevent="submitForm" :status-icon=true >
        <el-form-item prop="user_name">
          <el-input type="text" v-model="user.user_name" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="user.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="repeat_password">
          <el-input type="password" v-model="user.repeat_password" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item prop="tel">
          <el-input type="text" v-model="user.tel" placeholder="请输入手机号码">
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input type="text" v-model="user.code" placeholder="请输入验证码">
            <el-button slot="append" @click="obtain"  v-show="isCodeShow">发送验证码</el-button>
            <el-button class="disabled_btn" slot="append" :disabled="!isCodeShow" v-show="!isCodeShow" type="text">{{secondsCount}}秒后重发</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="invitation_code">
          <el-input type="text" v-model="user.invitation_code" placeholder="请输入邀请码">
          </el-input>
        </el-form-item>
        <el-form-item prop="check">
          <div class="rg_form_box_form_item">
            <el-checkbox v-model="user.checkBox"></el-checkbox>
            我已阅读并接受 <a @click="jump('userAgreement')">用户协议</a> 和 <a @click="jump('privacyAgreement')">隐私协议</a>
            <p></p>
          </div>
        </el-form-item>
        <div class="rg_form_box_form_item">
          <el-button type="primary" v-show="user.checkBox" class="rg_form_box_form_sub" @click="submitForm('registerForm')">注册</el-button>
          <el-button type="primary" v-show="!user.checkBox" class="rg_form_box_form_sub" disabled>注册</el-button>
        </div>
      </el-form>
      <!-- <div class="rg_three_box">
        <div class="rg_three_box_top">
          <el-divider content-position="center">使用第三方账号注册</el-divider>
        </div>
        <div class="rg_three_box_bootom">
          <span class="iconfont icon-weibo"></span>
          <span class="iconfont icon-weixin"></span>
          <span class="iconfont icon-qq"></span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'Register',
  data () {
    return {
      // 注册成功登陆加载
      loginLoading: false,
      // 倒计秒数初始化定义
      secondsCount: 0,
      // 是否显示发送验证码按钮
      isCodeShow: true,
      user: {
        user_name: '',
        password: '',
        repeat_password: '',
        tel: '',
        code: '',
        invitation_code: '', // 邀请码
        checkBox: false
      },
      rules: {
        user_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regexp = /^[A-Za-z]{1}[A-Za-z0-9_-]{3,15}$/
              if (!regexp.test(value)) {
                callback(new Error('用户名格式以字母开头，只能包含字母、数字、下划线、减号'))
              } else {
                callback()
              }
            }
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '长度最少8位', trigger: 'blur' }
        ],
        repeat_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === this.user.password) {
                callback()
              } else {
                callback(new Error('两次输入密码不一致'))
              }
            }
          }
        ],
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.length > 11 || value.length < 8) {
                callback(new Error('长度必须为11数字'))
              } else {
                const regexp = /^1[3456789]\d{9}$/
                if (!regexp.test(value)) {
                  callback(new Error('电话号码格式不对'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ],
        invitation_code: [
          { required: true, message: '请输入邀请码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 获取验证码
    async obtain () {
      const vueThat = this
      await vueThat.$store.dispatch('user/send', { number: vueThat.user.tel, type: 'login' }).then((res) => {
        if (res.data.code === 200) {
          vueThat.secondsCount = 60
          // 切换倒计时按钮
          vueThat.isCodeShow = false
          // 倒计时函数
          const timer = setInterval(function () {
            vueThat.secondsCount--
            if (vueThat.secondsCount <= 0) {
              clearInterval(timer)
              vueThat.isCodeShow = true
            }
          }, 1000)
        }
      })
    },
    // 表单验证
    async submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (vueThat.user.checkBox) {
            try {
              const passwordData = vueThat.user.password
              const userData = {
                user_name: vueThat.user.user_name,
                password: vueThat.user.password,
                repeat_password: vueThat.user.repeat_password,
                tel: vueThat.user.tel,
                code: vueThat.user.code,
                checkBox: vueThat.user.checkBox,
                invitation_code: vueThat.user.invitation_code
              }
              await vueThat.$store.dispatch('user/register', userData)
                .then(function (res) {
                  if (res.data.code === 200) {
                    vueThat.$alert('注册成功', '温馨提示', {
                      type: 'success',
                      iconClass: 'iconfont icon-icon_richeng_btn_pass',
                      confirmButtonText: '确定',
                      showClose: false,
                      callback: action => {
                        vueThat.loginLoading = true
                        try {
                          const userInfo = {
                            user_name: vueThat.user.user_name,
                            password: passwordData,
                            type: 1
                          }
                          vueThat.$store.dispatch('user/login', userInfo)
                            .then(async function (rs) {
                              if (rs.data.code === 200) {
                                vueThat.loginLoading = false
                                vueThat.$store.commit('user/updateUserInfo', {
                                  id: rs.data.data.user_id,
                                  name: rs.data.data.user_name,
                                  authorization: rs.data.data.token,
                                  sig: rs.data.data.sig,
                                  is_authentication: rs.data.data.is_authentication,
                                  portrait: rs.data.data.portrait,
                                  automatic: false
                                })
                                vueThat.$router.push({ name: 'Home' })
                              }
                            })
                        } catch (e) {}
                      }
                    })
                  }
                })
            } catch (e) {}
          } else {
            this.$alert('请勾选用户协议、隐私协议', '温馨提示', {
              type: 'erro',
              iconClass: 'iconfont icon-icon_richeng_btn_cancel',
              confirmButtonText: '确定',
              showClose: false
            })
          }
        } else {
          return false
        }
      })
    },
    // 页面跳转
    jump (type) {
      let url = ''
      switch (type) {
        case 'userAgreement':
          url = '/userAgreement'
          break
        case 'privacyAgreement':
          url = '/privacyAgreement'
          break
      }
      const routeData = this.$router.resolve({
        path: url
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
  .disabled_btn{
    padding:12px 15px;
    margin-left: 0
  }
</style>
